<template lang="pug">
.athletes.main-container
  .division(v-for="division in divisions")
    h3 {{__(division.name, 'auto')}}
    suspense
      template(#default)
        Athletes(:athletes="division.athletes")
      template(#fallback)
        AthletesLoading(:athletes="division.athletes")
</template>
<script setup lang="ts">
import AthletesLoading from './AthletesLoading.vue'

interface DivisionItem {
  name?: string;
  athletes?: any[];
}

const props = withDefaults(defineProps<{
  divisions?: DivisionItem[]
}>(), {
  divisions: () => [],
})

</script>
<style lang="scss" scoped>
.division {
  margin-bottom: $space-l;
}

.athlete-class {
  .athlete {
    display: flex;

    .name {
      font-weight: bold;
      padding-bottom: $space-xxs;
    }

    .photo {
      max-width: 90px;
      height: 90px;
      margin-right: $space-xs;
    }

    .country {
      display: flex;
      align-items: center;

      .flag-thumb {
        width: 38px;
        height: 24px;
        margin-right: $space-xxs;
        justify-content: center;
      }

      @include mobile() {
        flex-direction: column;
        align-items: flex-start;
        .flag-thumb {
          margin-bottom: $space-xs;
        }
      }
    }
  }
  }

</style>
